module.exports = __webpack_public_path__ + "img/HotelJHV24.7391c050.jpg";